/**
 * A slider row's "Lowest" flag (02/11/2026): set or cleared on the row, and
 * a newly picked metric starts on its natural side — a cost or a bad rate on
 * "Lowest" (shared `isLowerBetter`), anything else on "Highest".
 * For Media Devoted | Created By Ciro Autiero
 */
import { type FormulaSubMetric, isLowerBetter } from '@trafficpulse/shared';

/** The row with `lowest` on or off (off = no key, like every row saved before). */
export function withLowest(row: FormulaSubMetric, lowest: boolean): FormulaSubMetric {
  const { lowest: _was, ...rest } = row;
  return lowest ? { ...rest, lowest: true } : rest;
}

/** The row on a newly picked metric; where "Lowest" is offered it starts on the metric's natural side. */
export function pickMetric(row: FormulaSubMetric, metric: string, allowLowest: boolean): FormulaSubMetric {
  return withLowest({ ...row, metric }, allowLowest && isLowerBetter(metric));
}
